import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getScreenMedia
} from 'selectors';

class FixedHeightWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: this.getHeight()
    };
  }

  componentDidMount() {
    this.handleResize();
    // setTimeout(this.handleResize, 50);
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  getHeight = () => {
    const media = this.props.media;
    const headerHeight = 50;
    let padding = 0;
    if(media === 'small') {
      padding = 10;
    } else if(media === 'medium') {
      padding = 15;
    } else if(media === 'large') {
      padding = 20;
    }

    return window.innerHeight - headerHeight - padding;
  }

  handleResize = () => {
    this.setState({height: this.getHeight()});
  };

  render() {

    return (
      <div className="fixed-height-wrapper" style={{height: this.state.height}}>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    media: getScreenMedia(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(FixedHeightWrapper);
